/** Locale-aware short date (e.g. 29 Apr 2026 / Arabic Gregorian). */
export function formatDateV2(
  dateInput: string | Date,
  locale: string,
  useIslamicCalendar = false
): string {
  if (!dateInput) return "";

  const date =
    dateInput instanceof Date ? dateInput : new Date(dateInput);

  if (Number.isNaN(date.getTime())) return "";

  const isArabic = locale === "ar";

  const formatter = new Intl.DateTimeFormat(
    isArabic
      ? useIslamicCalendar
        ? "ar-SA-u-ca-islamic"
        : "ar-SA"
      : "en-GB",
    {
      day: "numeric",
      month: "short",
      year: "numeric",
    }
  );

  return formatter.format(date);
}
